import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-18828
// Пак ИИ Фичей / фейкдор
export const aiSetFakedoor: 'c' | 'd' | undefined = getFeature('ab-ai-fakedoor');
